var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"util-add"},[_c('router-link',{attrs:{"to":_vm.action}},[_c('button',[_c('img',{attrs:{"src":require("@/assets/img/util-pencil.svg"),"alt":""}}),_c('span',[_vm._v("Tambahkan Catatan")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }